import React, { useState, useContext, useEffect } from "react";
import { TimeEntryRepeaterProps } from "./TimeEntryRepeater.Interface";
import "./TimeEntryRepeater.scss";
import { ITimeEntry } from "../../Data/Models/ITimeEntry";
import { TimeEntry } from "../../Components/Library/TimeEntry/TimeEntry";
import { useTimeEntries, IUseTimeEntries } from "../../Hooks/useTimeEntries";
import nameof from "ts-nameof.macro";
import { EditModeContext } from "../../Context/EditModeContext/EditModeContext";
import { useGroups } from "../../Hooks/useGroups";
import { GroupTaskModalContext } from "../../Context/GroupTaskModalContext/GroupTaskModalContext";
import { GroupTaskModalContextDispatchActionType } from "../../Context/GroupTaskModalContext/GroupTaskModalContextDispatchActionType";
import { HistoryModel } from "../../Hooks/useHistory/HistoryModel";
import { useHistory } from "../../Hooks/useHistory/useHistory";
import { TheHook } from "../../Hooks/TheHook/TheHook";
import { TheHookModel } from "../../Hooks/TheHook/TheHookModel";
import { TheEditModeClaw } from "../../Hooks/TheHook/TheEditModeClaw";
import { ModalContext } from "../../Context/ModalContext/ModalContext";
import { ModalContextDispatchActionType } from "../../Context/ModalContext/ModalContextDispatchActionType";
import { GroupTaskModal } from "../../Components/Library/GroupTaskModal/GroupTaskModal";

export const TimeEntryRepeater = (props: TimeEntryRepeaterProps) => {
	const Groups = useGroups(nameof(TimeEntryRepeater));

	const groupTaskModalContext = useContext(GroupTaskModalContext);
	const editModeContext = useContext(EditModeContext);
	const modalContext = useContext(ModalContext);

	const [mergingGroup] = useState<string | undefined>(undefined); // This is currently how I'm handling relinking whole groups
	const history: HistoryModel = useHistory(nameof(TimeEntryRepeater));
	const theHook: TheHookModel = TheHook(nameof(TimeEntryRepeater), true);
	const editModeTimeEntries: IUseTimeEntries = useTimeEntries(
		nameof(TimeEntryRepeater),
		TheEditModeClaw.editModeTimeEntriesSubscribable
	);

	// This code adds a time entry that triggers the forgotten time entry view
	// HOW TO USE: Uncomment useEffect code, reload page, then comment it again and reload again.
	//
	// useEffect(()=>{
	// 	theHook.NewTimeEntry(InstanceManager.timeSource.GetTimeMom().startOf('day').subtract(4,'hour'))
	// },[])

	// ------------------------------------------------
	// MOVE THIS
	// const kairos = useKairos(nameof(TimeEntryRepeater));
	// useInterval(kairos.RunCallbacks, 1000);
	// ------------------------------------------------

	// ------------------------------------------------
	// MOVE THIS, THIS IS THE SOLE TRIGGER FOR UNDOREDO TO SET EDIT MODE

	useEffect(() => {
		if (history.state.present) {
			console.debug("present history", history.state.present);
			console.debug("past history", history.state.past);
			console.debug("future history", history.state.future);
			theHook.UndoRedoTriggered();
		}
	}, [editModeContext.state.undoRedoTrigger]);

	// ------------------------------------------------

	function ShowLinkButton() {
		// const group = Groups.Get(timeEntrySetGuid)

		// if (taskContext.state.activeTaskGuid) {
		// 	return true;
		// }
		// if (group) {
		// 	if (taskContext.state.activeGroupGuid) {
		// 		if (taskContext.state.activeGroupGuid === timeEntrySetGuid || !group.taskExternalId) {

		// 			return true;
		// 		}
		// 	}

		// }
		return false;
	}

	// function LinkToTask(TimeEntrySetGuid: string) {
	// 	props.LinkGroupToActiveTask(TimeEntrySetGuid)
	// }

	function UnlinkTimeEntrytFromGroup(timeEntry: ITimeEntry) {
		theHook.UnlinkTimeEntryFromGroup(timeEntry.timeEntryGuid);
	}

	function SetModalGroup(TimeEntrySetGuid?: string) {
		if (TimeEntrySetGuid) {
			const group = Groups.Get(TimeEntrySetGuid);

			if (group) {
				modalContext.dispatch({
					type: ModalContextDispatchActionType.SetModalComponent,
					payload: <GroupTaskModal />,
				});

				groupTaskModalContext.dispatch({
					type: GroupTaskModalContextDispatchActionType.SetModalTask,
					payload: undefined,
				});
				groupTaskModalContext.dispatch({
					type: GroupTaskModalContextDispatchActionType.SetModalGroup,
					payload: group,
				});

				modalContext.dispatch({
					type: ModalContextDispatchActionType.OpenModal,
					payload: undefined,
				});
			}
		}
	}

	return (
		<section className="time-units-wrapper" onContextMenu={props.HandleContextMenu}>
			{editModeTimeEntries
				.AllNotDeleted()
				.sort((a, b) => a.startedWhen.diff(b.startedWhen).milliseconds)
				.map((timeEntry) => {
					return (
						<TimeEntry
							key={"Time-Entry-" + timeEntry.timeEntryGuid}
							timeEntry={timeEntry}
							UnlinkTimeEntrytFromGroup={UnlinkTimeEntrytFromGroup}
							mergingGroupGuid={mergingGroup}
							SetModalGroup={SetModalGroup}
							theHook={theHook}
							ShowLinkButton={ShowLinkButton}
							scrollRef={props.scrollRef}
						/>
					);
				})}
		</section>
	);
};
